import axios from 'axios';
import { Leaderboard, LeaderboardEntry } from 'types/Leaderboard';

export const getLeaderboard = async (type: Leaderboard) => {
  let endpoint;

  switch (type) {
    case 'play-2-mint':
      endpoint = '/p2m-leaderboard.json';
      break;
    case 'the-big-break':
      endpoint = '/leaderboard-community.json';
      break;
    case 'the-big-break-top-scores':
      endpoint = '/leaderboard-community-top.json';
      break;
    default:
      throw new Error(`Unknown leaderboard type: ${type}`);
  }

  const { data } = await axios.get<LeaderboardEntry[]>(endpoint);
  return data;
};
